import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProducts = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Menu_Burger_Square",
	"data-name": "Menu, Burger, Square",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_7367",
			"data-name": "Path 7367",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_7368",
			"data-name": "Path 7368",
			d: "M8.5,15h7",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_7369",
			"data-name": "Path 7369",
			d: "M8.5,12h7",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_7370",
			"data-name": "Path 7370",
			d: "M8.5,9h7",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_7371",
			"data-name": "Path 7371",
			d: "M18,20H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H18a2,2,0,0,1,2,2V18A2,2,0,0,1,18,20Z",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgProducts;
